<template>
	<div class="treatments">
		<v-tabs
			vertical
			left
			color="primary"
			slider-color="primary"
			slider-size="3"
			background-color="secondary"
			active-class="primary--text"
			style="border-radius: 4px"
		>
			<v-tab class="text-caption" v-translate v-if="$store.getters.hasModule('mtc') || existMTC">TCM</v-tab>
			<v-tab class="text-caption" v-translate v-if="$store.getters.hasAnyModule || existNutrition">Nutrition</v-tab>
			<v-tab class="text-caption" v-translate v-if="$store.getters.hasModule('osteo') || existOsteo">Osteopathy</v-tab>
			<v-tab ref="supplementsTab" class="text-caption" v-translate v-if="$store.getters.hasModule('fito') || existFito">Supplements</v-tab>
			<v-tab v-for="customTreatment in customTreatments" :key="customTreatment.id" class="text-caption">{{customTreatment.name}}</v-tab>
			<v-divider></v-divider>
			<v-tab ref="prescriptionTab" class="text-caption" v-translate>Prescription</v-tab>
			<div style="height: 5px; background-color: white">
			</div>
			<v-btn class="text-caption primary--text" text @click="getAppointments" :loading="loadingAppointmentsToImport">
				<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
				<translate>History</translate>
				<v-dialog v-model="showAppointmentsToImport" max-width="60%" scrollable>
					<v-card>
						<v-card-title class="title primary--text mb-2 secondary">
							<translate>Import Treatments</translate>
						</v-card-title>
						<v-card-text class="pt-2">
							<p
								v-if="appointmentsToImport.length == 0"
								class="font-weight-thin ml-2"
								v-translate
							>No appointments.</p>
							<v-card v-else class="mx-auto mb-2" v-for="appointment in appointmentsToImport" :key="appointment.id">
								<v-list-item three-line>
									<v-list-item-content>
										<v-list-item-title class="primary--text">
											<v-row no-gutters class="text-body-1">
												<v-icon class="mr-1" small color="primary">mdi-account-tie</v-icon>
												<span class="mr-2">{{appointment.user.name}}</span>
												<v-icon class="mr-1" small color="primary">mdi-certificate</v-icon>
												<span>{{appointment.speciality.name}}</span>
												<v-spacer></v-spacer>
												<v-icon class="mr-1" small color="primary">mdi-calendar</v-icon>
												<span class="mr-2">{{appointment.date}}</span>
												<v-icon class="mr-1" small color="primary">mdi-clock-outline</v-icon>
												<span>{{appointment.time}}</span>
											</v-row>
										</v-list-item-title>
										<v-list-item-subtitle>{{appointment.description}}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-divider class="mx-4"></v-divider>
								<v-card-text>
									<v-row no-gutters>
										<ClinicHistoryTreatments @import-treatment="importTreatment" :loading="false" :appointment="appointment" :importOption="true" :loadingImportTreatment="loadingImportTreatment" />
									</v-row>
								</v-card-text>
							</v-card>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click="showAppointmentsToImport = false">
								<translate>Close</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-btn>
			<v-row style="background-color: white" no-gutters>
			</v-row>
			<v-tab-item :transition="false" :reverse-transition="false" v-if="$store.getters.hasModule('mtc') || existMTC">
				<v-container class="px-4">
					<v-expansion-panels>
						<v-expansion-panel key="tcm-plan">
							<v-expansion-panel-header>
								<span>
									<v-icon v-if="appointment.tcm_treatment_plan" color="primary" class="mr-3">check</v-icon>
									<strong v-translate>Treatment Plan</strong>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters class="pb-3">
									<v-col cols="12">
										<v-textarea
											@blur="editTreatmentPlan"
											:label="$gettext('Notes')"
											placeholder=" "
											filled
											hide-details
											v-model="appointment.tcm_treatment_plan"
											:disabled="!$store.getters.hasModule('mtc')"
											auto-grow
										></v-textarea>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
					<v-expansion-panels multiple v-model="mtcPanel" class="mt-5">
						<v-expansion-panel key="acu">
							<v-expansion-panel-header :color="existAcu ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">$vuetify.icons.acuIcon</v-icon>
									<span v-translate>Acupuncture</span>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters class="mt-2">
									<v-col cols="12">
										<Acupuncture key="acu-body" :openPad="existAcu ? false : true" @save-ashi="saveAshi" @save-notes="editNotes" :appointment="appointment" />
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel key="acu-auri">
							<v-expansion-panel-header :color="existAcuAuricular ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">$vuetify.icons.acuIcon</v-icon>
									<span v-translate>Auricular Acupuncture</span>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters class="mt-2">
									<v-col cols="12">
										<AcupunctureAuricular key="acu-auri" @save-notes="editNotes" :appointment="appointment" />
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel key="cmm">
							<v-expansion-panel-header :color="existCMM ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">$vuetify.icons.tcmIcon</v-icon>
									<translate>Chinese Materia Medica</translate>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters class="mt-2">
									<v-col cols="12">
										<ChineseMedicalMatter :formulas="formulas" />
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel key="qi-gong">
							<v-expansion-panel-header :color="existQiGong ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">mdi-yoga</v-icon>
									<span>Qi Gong</span>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters>
									<v-col cols="12">
										<GeneralTreatment
											name="Qi Gong"
											category="qg"
											key="qi-gong"
											:treatment="qiGongTreatment ? qiGongTreatment : {text: null}"
											@add-treatment="addTreatment"
											@remove-treatment="removeTreatment"
											@update-treatment="updateTreatments"
											ref="qg"
										/>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel key="tui-na">
							<v-expansion-panel-header :color="existTuiNa ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">mdi-hand-front-right</v-icon>
									<span>Tui Na</span>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters>
									<v-col cols="12">
										<GeneralTreatment
											name="Tui Na"
											category="tn"
											key="tui-na"
											:treatment="tuiNaTreatment ? tuiNaTreatment : {text: null}"
											@add-treatment="addTreatment"
											@remove-treatment="removeTreatment"
											@update-treatment="updateTreatments"
										/>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-container>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" v-if="$store.getters.hasAnyModule || existNutrition">
				<v-container class="px-4">
					<v-expansion-panels>
						<v-expansion-panel key="nutrition-plan">
							<v-expansion-panel-header>
								<span>
									<v-icon v-if="appointment.nut_treatment_plan" color="primary" class="mr-3">check</v-icon>
									<strong v-translate>Treatment Plan</strong>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters class="pb-3">
									<v-col cols="12">
										<v-textarea
											@blur="editTreatmentPlan"
											:label="$gettext('Notes')"
											placeholder=" "
											filled
											hide-details
											v-model="appointment.nut_treatment_plan"
											:disabled="!$store.getters.hasAnyModule"
											auto-grow
										></v-textarea>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
					<v-expansion-panels class="mt-5">
						<v-expansion-panel key="nut">
							<v-expansion-panel-header :color="existNutrition ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">mdi-food-apple</v-icon>
									<translate>Nutrition</translate>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters>
									<v-col cols="12">
										<GeneralTreatment
											name="Nutrition"
											category="nut"
											key="nut"
											:treatment="nutritionTreatment ? nutritionTreatment : {text: null}"
											@add-treatment="addTreatment"
											@remove-treatment="removeTreatment"
											@update-treatment="updateTreatments"
											ref="nut"
										/>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-container>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" v-if="$store.getters.hasModule('osteo') || existOsteo">
				<v-container class="px-4">
					<v-expansion-panels>
						<v-expansion-panel key="osteo">
							<v-expansion-panel-header :color="existOsteo ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">mdi-hand-front-right</v-icon>
									<translate>Osteopathy</translate>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters>
									<v-col cols="12">
										<GeneralTreatment
											name="Osteopathy"
											category="osteo"
											key="osteo"
											:treatment="osteoTreatment ? osteoTreatment : {text: null}"
											@add-treatment="addTreatment"
											@remove-treatment="removeTreatment"
											@update-treatment="updateTreatments"
											ref="osteo"
										/>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-container>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" v-if="$store.getters.hasModule('fito') || existFito">
				<v-container class="px-4">
					<v-expansion-panels>
						<v-expansion-panel key="fito-plan">
							<v-expansion-panel-header>
								<span>
									<v-icon v-if="appointment.supp_treatment_plan" color="primary" class="mr-3">check</v-icon>
									<strong v-translate>Treatment Plan</strong>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters class="pb-3">
									<v-col cols="12">
										<v-textarea
											@blur="editTreatmentPlan"
											:label="$gettext('Notes')"
											placeholder=" "
											filled
											hide-details
											v-model="appointment.supp_treatment_plan"
											:disabled="!$store.getters.hasModule('fito')"
											auto-grow
										></v-textarea>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
					<v-expansion-panels class="mt-5">
						<v-expansion-panel key="fito">
							<v-expansion-panel-header :color="existFito ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">mdi-pill</v-icon>
									<translate>Supplements</translate>
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters class="mt-2">
									<v-col cols="12">
										<Supplements :supplements="supplements" />
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-for="customTreatment in customTreatments"
				:key="customTreatment.id"
				:transition="false"
				:reverse-transition="false">
				<v-container class="px-4">
					<v-expansion-panels>
						<v-expansion-panel>
							<v-expansion-panel-header :color="customTreatment.treatment ? 'secondary' : ''">
								<span class="title font-weight-regular primary--text">
									<v-icon color="primary" class="mr-2">mdi-clipboard-text</v-icon>
									{{customTreatment.name}}
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row no-gutters>
									<v-col cols="12">
										<GeneralTreatment
											:name="customTreatment.name"
											:key="customTreatment.id"
											:treatment="customTreatment.treatment ? customTreatment.treatment : {text: null}"
											@add-treatment="addTreatment"
											@remove-treatment="removeTreatment"
											@update-treatment="updateTreatments"
											:customTreatment="customTreatment"
											:custom="true"
											:ref="customTreatment.id"
										/>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-container>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false">
				<v-container class="px-7">
					<Prescription
						:patient="patient"
						:existSupplements="existSupplements"
						:existNutrition="existNutrition"
						:existQiGong="existQiGong"
						:existCustomFormulas="existCustomFormulas"
					/>
				</v-container>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
import Acupuncture from "@/components/appointment/treatments/tcm/Acupuncture.vue";
import AcupunctureAuricular from "@/components/appointment/treatments/tcm/AcupunctureAuricular.vue";
import ChineseMedicalMatter from "@/components/appointment/treatments/tcm/ChineseMedicalMatter.vue";
import Supplements from "@/components/appointment/treatments/supplements/Supplements.vue";
import GeneralTreatment from "@/components/appointment/treatments/GeneralTreatment.vue";
import Prescription from "@/components/appointment/treatments/prescription/Prescription.vue";
import ClinicHistoryTreatments from "@/components/patient/ClinicHistoryTreatments.vue";
import axios from "axios";
import { mapGetters } from 'vuex'

export default {
	name: "Treatments",
	props: [
		"patient",
		"acuPoints",
		"supplements",
		"formulas",
		"generalTreatments",
		"customTreatments",
		"appointment"
	],
	components: {
		Acupuncture,
		AcupunctureAuricular,
		ChineseMedicalMatter,
		Supplements,
		GeneralTreatment,
		Prescription,
		ClinicHistoryTreatments
	},
	data: () => ({
		mtcPanel: [],
		showAppointmentsToImport: false,
		appointmentsToImport: [],
		loadingAppointmentsToImport: false,
		loadingImportTreatment: false
	}),
	methods: {
		getAppointments() {
			this.loadingAppointmentsToImport = true;
			const patientId = this.$route.params.pid;
			const appointmentId = this.$route.params.aid;
			axios
				.get(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/import_options", {params: {treatments: true}}
				)
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						this.appointmentsToImport = response.data.appointments;
						this.showAppointmentsToImport = true;
					}
					this.loadingAppointmentsToImport = false;
				})
				.catch(error => {
					console.log(error);
					this.loadingAppointmentsToImport = false;
				});
		},
		importTreatment(appointmentId, treatment) {
			this.loadingImportTreatment = true;
			axios
				.post(
					"/patient/" +
						this.appointment.patient_id +
						"/appointment/" +
						this.appointment.id +
						"/import-treatment/" +
						appointmentId, null, {params: {treatment: treatment}}
				)
				.then(response => {
					console.log(response.data);
					this.loadingImportTreatment = false;
					this.showAppointmentsToImport = false;
					if(treatment == 'supplements') this.supplements = response.data.supplements;
					else if(treatment == 'mmc') this.formulas = response.data.formulas;
					else if(treatment == 'acu' || treatment == 'auricular') this.$store.dispatch("SET_ACU_POINTS", {points: response.data.acu_points, ashi_points: this.appointment.ashi_points});
					else if(treatment == 'nut' || treatment == 'qg' || treatment == 'tn' || treatment == 'osteo') this.generalTreatments = response.data.general_treatments;
					else this.customTreatments = response.data.custom_treatments;
				})
				.catch(error => {
					console.log(error);
					this.loadingImportTreatment = false;
				});
		},
		saveAshi(text) {
			this.appointment.ashi_points = text;
		},
		addTreatment(treatment) {
			this.generalTreatments.push(treatment);
		},
		removeTreatment(treatment) {
			this.generalTreatments.splice(
				this.generalTreatments.indexOf(treatment),
				1
			);
		},
		updateTreatments(treatments) {
			var found = false;
			for (var t in this.generalTreatments) {
				if (this.generalTreatments[t].module == treatments[0].module) {
					this.generalTreatments[t] = treatments[0];
					found = true;
				}
			}
			if (!found) {
				this.generalTreatments.push(treatments[0]);
			}
		},
		editTreatmentPlan() {
			console.log("edit");
			const patientId = this.$route.params.pid;
			const appointmentId = this.$route.params.aid;
			const formData = new FormData();
			if (this.appointment.tcm_treatment_plan != null) {
				formData.append(
					"tcm_treatment_plan",
					this.appointment.tcm_treatment_plan
				);
			}
			if (this.appointment.supp_treatment_plan != null) {
				formData.append(
					"supp_treatment_plan",
					this.appointment.supp_treatment_plan
				);
			}
			if (this.appointment.nut_treatment_plan != null) {
				formData.append(
					"nut_treatment_plan",
					this.appointment.nut_treatment_plan
				);
			}
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/treatment_plans",
					formData
				)
				.then(response => {
					console.log(response.data);
				})
				.catch(error => console.log(error));
		},
		editNotes(auricular) {
			const appointmentId = this.$route.params.aid;
			let data = {
				op: auricular ? 'save_auricular_notes' : 'save_acu_notes'
			}
			if(auricular) data['auricular_notes'] = this.appointment.auricular_notes;
			else data['acu_notes'] = this.appointment.acu_notes;
			axios
				.post("/acupuncture/appointment/" + appointmentId, data)
				.then(response => {
					console.log(response.data);
				})
				.catch(error => console.log(error));
		},
		containsObject(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].id == obj.id) {
					return true;
				}
			}
			return false;
		}
	},
	computed: {
		qiGongTreatment() {
			const treatments = this.generalTreatments.filter(t => t.module === "qg");
			if (treatments.length == 0) return null;
			else return treatments[0];
		},
		tuiNaTreatment() {
			const treatments = this.generalTreatments.filter(t => t.module === "tn");
			if (treatments.length == 0) return null;
			else return treatments[0];
		},
		nutritionTreatment() {
			const treatments = this.generalTreatments.filter(t => t.module === "nut");
			if (treatments.length == 0) return null;
			else return treatments[0];
		},
		osteoTreatment() {
			const treatments = this.generalTreatments.filter(t => t.module === "osteo");
			if (treatments.length == 0) return null;
			else return treatments[0];
		},
		existSupplements() {
			return (
				this.supplements.products.length > 0 ||
				this.formulas.products.length > 0
			);
		},
		existCustomFormulas() {
			for(let i=0; i < this.formulas.products.length; i++) {
				let formula = this.formulas.products[i].product;
				if(formula.classic_custom || formula.lab_custom) return true;
			}
			return false;
		},
		existNutrition() {
			return this.nutritionTreatment != null;
		},
		existCMM() {
			return this.formulas.products.length > 0;
		},
		existAcu() {
			return this.acuPoints.filter(p => !p.auricular).length > 0;
		},
		existAcuAuricular() {
			return this.acuPoints.filter(p => p.auricular).length > 0;
		},
		existQiGong() {
			return this.qiGongTreatment != null;
		},
		existTuiNa() {
			return this.tuiNaTreatment != null;
		},
		existMTC() {
			if(this.existTuiNa || this.existQiGong || this.existCMM || this.existAcu || this.existAcuAuricular) return true;
			return false;
		},
		existFito() {
			return this.supplements.products.length > 0;
		},
		existOsteo() {
			const treatments = this.generalTreatments.filter(t => t.module === "osteo");
			if (treatments.length == 0) return null;
			else return treatments[0];
		},
		...mapGetters({
      tourStep: 'tourStepEvent'
    })
	},
	watch: {
		tourStep(value) {
			if(value == 'tour-acu-open') {
				this.mtcPanel = [0];
			}
			else if(value == 'tour-go-to-patients') {
				this.$router.push({name: 'patients'});
			}
			else if(value == 'tour-prescription') {
				this.$refs.prescriptionTab.$el.click();
			}
			else if(value == 'tour-treatments-supplements') {
				this.$refs.supplementsTab.$el.click();
			}
		}
	}
};
</script>

<style scoped>
.v-tab {
	justify-content: left !important;
	min-width: 240px;
}
</style>